import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { OrderDetailComponent } from '../order-detail/order-detail.component';
import { OrderState } from 'src/app/models/virtual-store/order-state.model';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { OrderService } from 'src/app/services/order.service';
import { Account } from 'src/app/models/account.model';
import { Order } from 'src/app/models/virtual-store/order.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { OrderFnb } from 'src/app/models/virtual-store/orderFnb.model';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent implements OnInit {
  orderStateList: OrderState[] = [];
  orderStateListFnb: OrderState[] = [];
  orderList: Order[] = [];
  orderFnbList:OrderFnb[] = [];
  isLineCreditLineFnb:boolean
  account: Account;

  /**Subscripción a cuenta seleccionada  */
  accountSelectedSubscription: Subscription;
  constructor(public dialog: MatDialog,
              private commonService: CommonService,
              private virtualStoreService: VirtualStoreService,
              private orderService: OrderService,
              private authService:AuthService) {
    this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced.subscribe(account => {
      this.account = account;  
      this.listOrders();     
    });
  }

  ngOnInit() {
    this.listOrderStates();
  }
  ngOnDestroy() {
    this.accountSelectedSubscription.unsubscribe();
  }
  listOrderStates() {
    this.virtualStoreService.listOrderStates().subscribe(response => {
      this.orderStateList = response.data;   
    });
  }
  listOrders() {
   let basicData=this.authService.getBasicData();
   this.isLineCreditLineFnb=this.authService.getCreditLineFNB().isCreditLineFNB;
   if(this.isLineCreditLineFnb){
    this.orderService.listFnb(basicData.documentType, basicData.documentNumber).subscribe(response => {
      this.orderFnbList = response.data;    
    });
   }else{
    this.orderService.list(this.account.clientCode).subscribe(response => {
      this.orderList = response.data;    
    });
   }   
  }
  openDialog(order: any) {    
    this.dialog.open(OrderDetailComponent, {
      disableClose: true,
      data: {
        order,
        orderStateList: this.orderStateList,
        isFnb:this.isLineCreditLineFnb
      }
    });
  }
  getStatesFnb(idEstado: number, nombreEstado:string){
    this.orderStateListFnb=
        [         
          {"id":1,
           description:"Pendiente de Entrega"
          }       
        ];    
    if(idEstado > 1){
      let estado={"id":idEstado,
                  "description":nombreEstado}
      this.orderStateListFnb.push(estado);
    }else{
      let estado={"id":2,
                  "description":"Entregado"}
      this.orderStateListFnb.push(estado);
    }     
    return this.orderStateListFnb;
  }
}
